import styled from 'styled-components';

const SectionColumn = styled.div`
  width: 100%;
  display: ${props => (props.center ? 'flex' : null)};
  align-items: ${props => (props.center ? 'center' : null)};
  justify-content: ${props => (props.center ? 'center' : null)};
  margins: ${props => (props.center ? '0 auto' : null)};
`;

export default SectionColumn;
